import {
  cardRecommendationsId,

  cardTopCampaignsId,
  cardTopKeywordsId,
  cardSearchTermsId,
  cardTopAdGroupsId,
  cardTopAccountsId,
  cardConversionTrackingId,

  cardTopChangesAccountId,
  cardTopChangesCampaignId,
  cardTopChangesAdGroupId,
} from '@bingads-webui-campaign/fluent-page-consts';

import { conversionTrackingDeps } from './conversion-tracking-imports';
import { tableDeps } from './grid-card-imports';
import { recommendationsDeps } from './recommendations-imports';
import { topChangesLegacyDeps } from './top-changes-imports';

export const legacyDeps = {
  [cardRecommendationsId]: recommendationsDeps,
  [cardTopCampaignsId]: tableDeps,
  [cardTopAccountsId]: tableDeps,
  [cardTopKeywordsId]: tableDeps,
  [cardSearchTermsId]: tableDeps,
  [cardTopAdGroupsId]: tableDeps,
  [cardConversionTrackingId]: conversionTrackingDeps,
  [cardTopChangesAccountId]: topChangesLegacyDeps,
  [cardTopChangesCampaignId]: topChangesLegacyDeps,
  [cardTopChangesAdGroupId]: topChangesLegacyDeps,
};
